export function getQueryParam(name: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

export function epochToDate(epoch: number) {
  // Convert to a number if it's a string
  epoch = Number(epoch);

  // If 10 digits, assume seconds and multiply by 1000
  if (epoch < 1e12) {
    epoch *= 1000;
  }

  return new Date(epoch);
}